import fetch from 'cross-fetch';
import { LoginRequest } from './login';
import { ErrorResponse, RedirectResponse } from '../response';
import { RedirectAction, sameOriginRequestPolicy } from '../actions';
import { RequiredBodyError } from '../error';

export const LoginErrorIdentifierNotExist = 'be.api.auth.login-failed-id';

export class RemoteLoginAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: RedirectAction<LoginRequest> = async (loginRequest?: LoginRequest): Promise<RedirectResponse | ErrorResponse> => {
		const base: string = this.baseUrl || '';
		if (!loginRequest) {
			throw new RequiredBodyError();
		}

		try {
			const response: Response = await fetch(`${base}/api/login`, {
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(loginRequest)
			});

			const jsonResponse = await response.json();
			return { ...jsonResponse, status: response.status };
		} catch (e: unknown) {
			throw new Error('unexpected');
		}
	};
}
